(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

/* ── Sticky Header ─────────────────────────────────────── */
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.createObserver();
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    const obs = new IntersectionObserver(entries => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    obs.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide()   { this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); }
  reveal() { this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
  reset()  { this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
}
customElements.define('sticky-header', StickyHeader);

/* ── Localization ─────────────────────────────────────── */
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.els = {
      input: this.querySelector('input[name="locale_code"],input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    if (!this.els.button) return;
    this.els.button.addEventListener('click', this.openSelector.bind(this));
    this.els.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', e => { if(e.code==='Escape'){this.hidePanel();this.els.button.focus();} });
    this.querySelectorAll('a').forEach(a => a.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() { this.els.button.setAttribute('aria-expanded','false'); this.els.panel.setAttribute('hidden',true); }
  onItemClick(e) { e.preventDefault(); const f=this.querySelector('form'); this.els.input.value=e.currentTarget.dataset.value; if(f)f.submit(); }
  openSelector() { this.els.panel.toggleAttribute('hidden'); this.els.button.setAttribute('aria-expanded',(this.els.button.getAttribute('aria-expanded')==='false').toString()); }
  closeSelector(e) { if(e.relatedTarget===null||e.relatedTarget?.nodeName==='BUTTON') this.hidePanel(); }
}
customElements.define('localization-form', LocalizationForm);

/* ── Animated Placeholder ─────────────────────────────── */
function initAnimatedSearch(input) {
  const terms = (input.dataset.searchTerms||'').split('|').map(s=>s.trim()).filter(Boolean);
  if (!terms.length) return;
  const cycleEl = input.closest('.ph-search-placeholder-wrap')?.querySelector('.ph-search-label__cycle');
  if (!cycleEl) {
    // overlay mode
    let idx=0;
    const prefix = (input.placeholder.split(' ')[0]||'Search') + ' ';
    function nextO(){ input.setAttribute('placeholder', prefix+terms[idx]); idx=(idx+1)%terms.length; }
    nextO(); setInterval(nextO,2800); return;
  }
  let idx=0;
  function next(){
    cycleEl.innerHTML='';
    const s=document.createElement('span');
    s.textContent=terms[idx];
    s.style.cssText='display:block;animation:phPlaceholderSlide 2.8s ease-in-out infinite';
    cycleEl.appendChild(s);
    idx=(idx+1)%terms.length;
  }
  next(); setInterval(next,2800);
}

/* ── Search Overlay ───────────────────────────────────── */
function initSearchOverlay() {
  const overlay = document.getElementById('phSearchOverlay');
  if (!overlay) return;
  const closeBtn = document.getElementById('phOverlayClose');
  const backdrop = document.getElementById('phSearchBackdrop');
  const inp = document.getElementById('phOverlayInput');
  const triggers = [
    document.getElementById('phSearchTrigger'),
    document.getElementById('phSearchTrigger2'),
    document.getElementById('phMobileSearch')
  ].filter(Boolean);

  function open()  { overlay.removeAttribute('hidden'); document.body.style.overflow='hidden'; inp?.focus(); if(inp)initAnimatedSearch(inp); }
  function shut()  { overlay.setAttribute('hidden',''); document.body.style.overflow=''; }

  triggers.forEach(t => t.addEventListener('click', open));
  closeBtn?.addEventListener('click', shut);
  backdrop?.addEventListener('click', shut);
  document.addEventListener('keydown', e=>{ if(e.key==='Escape'&&!overlay.hidden) shut(); });
}

/* ── Mobile Drawer ────────────────────────────────────── */
function initDrawer() {
  const toggle = document.getElementById('phDrawerToggle');
  const drawer = document.getElementById('phDrawer');
  const overlay = document.getElementById('phDrawerOverlay');
  const closeBtn = document.getElementById('phDrawerClose');
  if (!drawer) return;

  function open()  { drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow='hidden'; }
  function shut()  { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow=''; }

  toggle?.addEventListener('click', open);
  closeBtn?.addEventListener('click', shut);
  overlay?.addEventListener('click', shut);
  document.addEventListener('keydown', e=>{ if(e.key==='Escape'&&drawer.classList.contains('is-open')) shut(); });
}

/* ── Category Dropdown ────────────────────────────────── */
function initCategoryMenu() {
  const btn = document.getElementById('phCatBtn');
  const dd = document.getElementById('phCatDropdown');
  if (!btn || !dd) return;
  btn.addEventListener('click', e => {
    e.stopPropagation();
    const open = dd.classList.contains('is-open');
    dd.classList.toggle('is-open', !open);
    btn.setAttribute('aria-expanded', String(!open));
  });
  document.addEventListener('click', () => { dd.classList.remove('is-open'); btn?.setAttribute('aria-expanded','false'); });
  document.addEventListener('keydown', e => { if(e.key==='Escape') { dd.classList.remove('is-open'); btn?.setAttribute('aria-expanded','false'); } });
}

/* ── Mobile search row toggle ─────────────────────────── */
function initMobileSearch() {
  const btn = document.getElementById('phMobileSearch');
  const row = document.getElementById('phMobileSearchRow');
  if (!btn || !row) return;
  // Search row already shown; button on mobile opens overlay if search_style=icon
  // If search_box, the row is always visible
}

/* ── Init ─────────────────────────────────────────────── */
document.querySelectorAll('.ph-search-input').forEach(initAnimatedSearch);
initSearchOverlay();
initDrawer();
initCategoryMenu();
initMobileSearch();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
